<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == `${to.meta.abrev}-portal-do-cliente` || to.name == 'portal-do-cliente-list') {
            next({ name: `${to.meta.abrev}-portal-do-cliente-list` });
        } else {
            next();
        }
    },
    created() {
        if (
            this.$route.name == `${this.$route.meta.abrev}-portal-do-cliente` ||
            this.$route.name == 'portal-do-cliente'
        ) {
            this.$router.push({ name: `${this.$route.meta.abrev}-portal-do-cliente-list` });
        }
    },
};
</script>
